module.exports = __webpack_public_path__ + "img/img.407da03b.png";